(function () {
  'use strict';

  angular.module('app').component('invoiceSelectBooking', invoiceSelectBooking());

  function invoiceSelectBooking() {
    return {
      bindings: {
        invoice: '=',
        client: '<',
        onBookingSelected: '&',
      },
      controller: InvoiceSelectBookingComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/invoices/components/invoice-select-booking/invoice-select-booking.component.html',
    };
  }

  InvoiceSelectBookingComponent.$inject = ['CONFIGURATIONS', 'UtilService', 'BookingService'];

  function InvoiceSelectBookingComponent(config, UtilService, BookingService) {
    const vm = this;

    // public properties
    // -----------------------

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY_SHORT;
    vm.hourDisplay = config.HOUR_DISPLAY;

    vm.$onInit = function () {
      vm.selectedAll = false;

      getBookings();
    };

    // public methods
    // -----------------------
    vm.selectBooking = function (booking) {
      vm.booking = booking;
      vm.selectedAll = false;
    };

    vm.selectAll = function () {
      vm.booking.booking_items.forEach(function (item) {
        if (item.invoice_product_ids.length === 0) {
          item.selected = vm.selectedAll;
        }
      });
    };

    vm.atLeastOneBookingSelected = function () {
      if (vm.booking) {
        for (var i = 0; i < vm.booking.booking_items.length; i++) {
          if (vm.booking.booking_items[i].selected) {
            return true;
          }
        }
      }

      return false;
    };

    vm.checkBookingItemQuantity = function (booking_item) {
      if (!booking_item.quantity) {
        booking_item.quantity = 1;
      }
    };

    vm.confirmBookingSelected = function () {
      var booking = {
        id: vm.booking.id,
        booking_number: vm.booking.booking_number,
        currencyId: vm.booking.currency_id,
        saleConditionId: vm.booking.sale_condition_id,
        saleChannelId: vm.booking.sale_channel_id,
        saleSourceId: vm.booking.sale_source_id,
        salePersonId: vm.booking.user_id,
        bookingInUsed: vm.booking.invoices_in_used,
        booking_items: [],
        transaction_taxes: vm.booking.transaction_taxes,
      };

      vm.booking.booking_items.forEach(function (bookingItem) {
        var found = false;
        vm.invoice.invoice_products.forEach(function (product) {
          if (product.booking_item_id === bookingItem.id) {
            bookingItem.price = bookingItem.quantity * bookingItem.price_per_pax;

            product.quantity = bookingItem.quantity;
            // product.maxQuantity = bookingItem.maxQuantity;
            product.price = bookingItem.price;
            product.booking_item_unit_price = product.price / product.quantity;
            product.unit_price = vm.UtilService.roundNum(product.booking_item_unit_price);

            var price = product.booking_item_unit_price - product.discount + product.tax_amount;
            product.booking_item_total_price = product.quantity * price;
            product.total_price = vm.UtilService.roundNum(product.booking_item_total_price);

            found = true;
          }
        });

        if (bookingItem.selected && !found) {
          bookingItem.price = bookingItem.quantity * bookingItem.price_per_pax;
          booking.booking_items.push(bookingItem);
        }
      });

      vm.onBookingSelected({ booking: booking });
    };

    // private methods
    // -----------------------
    function getBookings() {
      let params = {
        get: 'by_client',
        client_id: vm.client.id,
      };

      vm.loadingAvailableBookings = true;
      BookingService.getBookings(params).then(function (data) {
        vm.bookings = filterBookings(data.items);

        searchBooking();
        vm.loadingAvailableBookings = false;
      });
    }

    function filterBookings(bookings) {
      let newBookings = [];

      bookings.forEach(function (booking) {
        let newBooking = angular.copy(booking);
        newBooking.booking_items = [];

        booking.booking_items.forEach(function (bookingItem) {
          let includesBookingId = vm.invoice.booking_ids.includes(booking.id);

          if (bookingItem.invoice_status !== 'invoiced' || includesBookingId) {
            let extraPrice = bookingItem.extraPrices ? bookingItem.extraPrices : 0;
            let quantity =
              bookingItem.infants + bookingItem.seniors + bookingItem.adults + bookingItem.children;

            bookingItem.price_per_pax = (bookingItem.item_price + extraPrice) / quantity;
            // bookingItem.maxQuantity = quantity - bookingItem.paxes_invoiced;
            bookingItem.quantity = quantity; //- bookingItem.paxes_invoiced;

            // if (bookingItem.quantity === 0) {
            //     bookingItem.quantity    = quantity;
            //     bookingItem.maxQuantity = quantity;
            // }

            newBooking.booking_items.push(bookingItem);
          }
        });

        if (newBooking.booking_items.length > 0) {
          newBooking.invoices_in_used = getInvoicesInUsed(newBooking);
          newBookings.push(newBooking);
        }
      });

      return newBookings;
    }

    function getInvoicesInUsed(bookingItem) {
      let count = 0;

      bookingItem.invoice_ids.forEach(function (id) {
        if (id !== vm.invoice.id) {
          count = count + 1;
        } else if (id === vm.invoice.id && bookingItem.invoice_ids > 1) {
          count = count + 1;
        }
      });

      return count;
    }

    function searchBooking() {
      vm.bookings.forEach(function (booking) {
        vm.invoice.booking_ids.forEach(function (bookingId) {
          if (bookingId === booking.id) {
            searchBookingItems(booking);
          }
        });
      });
    }

    function searchBookingItems(booking) {
      booking.booking_items.forEach(function (bookingItem) {
        vm.invoice.invoice_products.forEach(function (product) {
          if (bookingItem.id === product.booking_item_id) {
            bookingItem.selected = true;
            bookingItem.quantity = product.quantity;
          }
        });
      });
    }
  }
})();
